import { render, staticRenderFns } from "./dashFaturamento.vue?vue&type=template&id=e88849e8"
import script from "./dashFaturamento.vue?vue&type=script&lang=js"
export * from "./dashFaturamento.vue?vue&type=script&lang=js"
import style0 from "./dashFaturamento.vue?vue&type=style&index=0&id=e88849e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports